const normalizedKey = filter => `${filter?.key || ''}`.replace(/[-_\s]/g, '').toLowerCase();

const filterDefinitions = [
  { keys: ['category', 'categorylevel', 'genre'], label: 'Genre' },
  { keys: ['author', 'bookauthor'], label: 'Author', author: true },
  {
    keys: ['editiontype', 'specialedition', 'signed', 'signedpreference', 'rareoutofprint'],
    label: 'Edition Type',
  },
  {
    keys: ['editionsource', 'originalsource', 'editionsubscriptionbox', 'subscriptionbox'],
    label: 'Edition Source',
    compactOptions: 6,
  },
  { keys: ['format', 'bookformat', 'binding'], label: 'Format' },
  { keys: ['condition', 'conditiongrade'], label: 'Condition' },
  { keys: ['price'], label: 'Price' },
  { keys: ['language'], label: 'Language' },
  { keys: ['extrasincluded', 'extras'], label: 'Extras Included' },
  { keys: ['sellerprovince', 'province'], label: 'Seller Province' },
  { keys: ['acceptoffers'], label: 'Accepting offers', selectOne: true },
];

const matchesDefinition = (filter, definition) => definition.keys.includes(normalizedKey(filter));

export const filterDebugSummary = filters =>
  (filters || []).map(filter => ({
    key: filter.key,
    schemaType: filter.schemaType,
    label: filter.filterConfig?.label,
    showFilter: filter.filterConfig?.showFilter,
    indexForSearch: filter.filterConfig?.indexForSearch,
    listingTypes: filter.listingTypeConfig?.listingTypeIds || 'all',
  }));

const sourcePriority = [
  'fairyloot',
  'illumicrate',
  'afterlight',
  'owlcrate',
  'bookishbox',
  'litjoy',
  'pagewick',
];

const sortEditionSources = options =>
  [...(options || [])].sort((left, right) => {
    const leftIndex = sourcePriority.indexOf(normalizedKey({ key: left.option || left.label }));
    const rightIndex = sourcePriority.indexOf(normalizedKey({ key: right.option || right.label }));
    return (
      (leftIndex < 0 ? sourcePriority.length : leftIndex) -
      (rightIndex < 0 ? sourcePriority.length : rightIndex)
    );
  });

/**
 * Orders only hosted, indexed filters into PageHop's Marketplace drawer hierarchy.
 * `author` takes precedence over legacy `bookAuthor` so it is never rendered twice.
 */
export const organizeMarketplaceFilters = (availableFilters = []) => {
  const remaining = [...availableFilters];
  const organized = [];

  filterDefinitions.forEach(definition => {
    const matching = remaining.filter(filter => matchesDefinition(filter, definition));
    const selected = definition.author
      ? matching.find(filter => normalizedKey(filter) === 'author') || matching[0]
      : matching.find(filter => normalizedKey(filter) === definition.keys[0]) || matching[0];

    if (selected) {
      organized.push({
        ...selected,
        filterConfig: { ...selected.filterConfig, label: definition.label },
        ...(definition.compactOptions
          ? { enumOptions: sortEditionSources(selected.enumOptions) }
          : {}),
        ...(definition.compactOptions ? { compactOptions: definition.compactOptions } : {}),
        ...(definition.selectOne
          ? {
              filterConfig: {
                ...selected.filterConfig,
                label: definition.label,
                filterType: 'SelectSingleFilter',
              },
            }
          : {}),
      });
      if (!definition.author) {
        matching.filter(filter => filter !== selected).forEach(filter => organized.push(filter));
      }
      matching.forEach(filter => {
        const index = remaining.indexOf(filter);
        if (index >= 0) remaining.splice(index, 1);
      });
    }
  });

  return [...organized, ...remaining];
};

export { normalizedKey };